import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
import general from '../../../modulos/general';

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelLista = ({elementoI, handleClickidListaI, idListaI}) => {
  return( 
    <tr className='' onClick={(ev)=>handleClickidListaI(ev, elementoI)}>
    {/* <tr className=''> */}
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.cantidadCoti}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrUnidad}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrProducto}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{new Intl.NumberFormat('de-DE').format(elementoI.valorUniCoti)}</td> 
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.moneda}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcDcto}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIncremento}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{new Intl.NumberFormat('de-DE').format(elementoI.cantidadCoti * ((elementoI.valorUniCoti / ((100-elementoI.porcIncremento)/100)) * ((100-elementoI.porcDcto)/100)))}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIVA}</td>
    </tr>
  )
};


const Lista = ({listI, handleClickidListaI, idListaI}) => {
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} handleClickidListaI={handleClickidListaI} idListaI={idListaI}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Fin dropdown EMPRESAS
const DetallePolNivel1 = props => {
  return (
    <option dato1={props.elemento.descrPolitica} dato2={props.elemento.tipoProducto} 
    dato3={props.elemento.titulo2?props.elemento.titulo2:""} 
    dato4={props.elemento.parrafo2?props.elemento.parrafo2:""} 
    dato5={props.elemento.titulo3?props.elemento.titulo3:""} 
    dato6={props.elemento.parrafo3?props.elemento.parrafo3:""}>{props.elemento.titulo}</option>

  )
};

const ListaPol = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetallePolNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="titulo" id="miLista1" value={permiteUpdate?argsDocum.titulo:idLista.titulo} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {/* <option value="">Seleccionar...</option> */}
        {Nivel2Detalle}
      </select>
    </div>
  )
}; 

const DetalleConNivel1 = props => {
  return (
    <option dato1={props.elemento.ciudad?props.elemento.ciudad:""} dato2={props.elemento.cargo?props.elemento.cargo:""} dato3={props.elemento.email?props.elemento.email:""} dato4={props.elemento.telefono?props.elemento.telefono:""}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaCon = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleConNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreContacto" id="miLista3" value={permiteUpdate?argsDocum.nombreContacto:idLista.nombreContacto} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {/* <option value="">Seleccionar...</option> */}
        {Nivel3Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.consecProducto?props.elemento.consecProducto:0} 
    dato2={props.elemento.consecServicio?props.elemento.consecServicio:0} 
    dato3={props.elemento.consecPrograma?props.elemento.consecPrograma:0} 
    dato4={props.elemento.codEmpresa?props.elemento.codEmpresa:""}
    dato5={props.elemento.pais?props.elemento.pais:"Colombia"}>{props.elemento.descrEmpresa}</option>
  )
  };
  
const ListaEmp = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" value={permiteUpdate?argsDocum.descrEmpresa:idLista.descrEmpresa?idLista.descrEmpresa:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} dato2={props.elemento.ciudad?props.elemento.ciudad:""} dato3={props.elemento.email?props.elemento.email:""} dato4={props.elemento.telefono?props.elemento.telefono:""} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaOpe = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista2" value={permiteUpdate?argsDocum.nombreUsuario:idLista.nombreUsuario} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {/* <option value="">Seleccionar...</option> */}
        {Nivel4Detalle}
      </select>
    </div>
  )
};

const ListaEnt = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tiempoEntrega" id="miLista7" value={permiteUpdate?argsDocum.tiempoEntrega:idLista.tiempoEntrega} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>2-5 días hábiles</option>
        <option>6-9 días hábiles</option>
        <option>{">"} 10 días hábiles</option>
        <option>A convenir</option>
      </select>
    </div>
  )
};

const ListaPago = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="formaPago" id="miLista5" value={permiteUpdate?argsDocum.formaPago:idLista.formaPago} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Anticipado 100%</option>
        <option>Anticipo 50% contra entrega 50%</option>
        <option>Contra entrega 100%</option>
        <option>Pago {"="} 30 días</option>
        <option>Pago entre 30 {">="} y {"<"} 60 días</option>
        <option>Pago entre 60 {">="} y {"<"} 90 días</option>
        <option>Pago {">="} 90 días</option>
      </select>
    </div>
  )
};

const ListaOfer = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="validezOferta" id="miLista6" value={permiteUpdate?argsDocum.validezOferta:idLista.validezOferta} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>1 día</option>
        <option>3 días</option>
        <option>8 días</option>
        <option>15 días</option>
        <option>30 días</option>
        <option>60 días</option>
        <option>90 días</option>
      </select>
    </div>
  )
};

const ListaMon = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="monedaCoti" id="miLista55" value={permiteUpdate?argsDocum.monedaCoti:idLista.monedaCoti} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Pesos</option>
        <option>Dolares</option>
      </select>
    </div>
  )
};

const ListaSN = ({nameLista, idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name={nameLista} id={nameLista} value={permiteUpdate?argsDocum[nameLista]:idLista[nameLista]?idLista[nameLista]:"Seleccionar..."} onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>No</option>
        <option>Si</option>
      </select>
    </div>
  )
};

class VerCotizacion2 extends React.Component {
  state={
    argsDocum: {
      estadoCoti: this.props.idLista.estadoCoti,
      numCoti: this.props.idLista.numCoti,
      pais: this.props.idLista.pais?this.props.idLista.pais:"", 
      descrEmpresa: this.props.idLista.descrEmpresa,
      titulo: this.props.idLista.titulo, 
      descrPolitica: this.props.idLista.descrPolitica,
      titulo2: this.props.idLista.titulo2?this.props.idLista.titulo2:"", 
      parrafo2: this.props.idLista.parrafo2?this.props.idLista.parrafo2:"", 
      titulo3: this.props.idLista.titulo3?this.props.idLista.titulo3:"", 
      parrafo3: this.props.idLista.parrafo3?this.props.idLista.parrafo3:"", 
      ciudadFechaEnvio: this.props.idLista.ciudadFechaEnvio,
      nombreContacto: this.props.idLista.nombreContacto,
      ciudadContacto: this.props.idLista.ciudadContacto,
      cargoContacto: this.props.idLista.cargoContacto,
      mailContacto: this.props.idLista.mailContacto,
      telContacto: this.props.idLista.telContacto,
      referencia: this.props.idLista.referencia,
      tiempoEntrega: this.props.idLista.tiempoEntrega,
      lugarEntrega: this.props.idLista.lugarEntrega,
      formaPago: this.props.idLista.formaPago,
      validezOferta: this.props.idLista.validezOferta,
      observaciones: this.props.idLista.observaciones?this.props.idLista.observaciones:"",
      cedula: this.props.idLista.cedula,
      nombreUsuario: this.props.idLista.nombreUsuario,
      ciudad: this.props.idLista.ciudad?this.props.idLista.ciudad:"", 
      email: this.props.idLista.email?this.props.idLista.email:"", 
      telefono: this.props.idLista.telefono?this.props.idLista.telefono:"",
      tipo: this.props.idLista.tipo,
      fechaCreate: this.props.idLista.fechaCreate,
      fechaAut: this.props.idLista.fechaAut?this.props.idLista.fechaAut:"",
      usuarioAut: this.props.idLista.usuarioAut?this.props.idLista.usuarioAut:"",
      observacionesAut: this.props.idLista.observacionesAut?this.props.idLista.observacionesAut:"",
      monedaCoti: this.props.idLista.monedaCoti?this.props.idLista.monedaCoti:"",
      zonaFranca: this.props.idLista.zonaFranca?this.props.idLista.zonaFranca:"",
      gestionIngreso: this.props.idLista.gestionIngreso?this.props.idLista.gestionIngreso:"",
      _id: this.props.idLista._id
    },
    confirmaAct: false, descrProductoI: "", permiteBtn1: true, permiteBtn2: true, procBtn: 0, checked: false, 
    open: false, lista4: [], addItem: this.props.addItem, itemMod: "N", productoI: '', numProductoCotiI: 0, productoCotiI: 0, 
    argsQuery: `{"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
        descrProducto: '$itemsCoti.descrProducto', 
        numProductoCoti: '$itemsCoti.numProductoCoti', 
        cantidadCoti: '$itemsCoti.cantidadCoti', 
        valorUniCoti: '$itemsCoti.valorUniCoti', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad',
        moneda: '$itemsCoti.moneda'}},
    {$sort: {descrProducto: 1}}`
  }

  handleChange = (ev, argsDocum) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name==="aprobarCoti"){
        this.setState({checked: ev.target.checked})
      }      
      if(ev.target.name === "nombreContacto"){
        let miLista = document.getElementById("miLista3");
        argsDocum['nombreContacto'] = miLista.options[miLista.selectedIndex].text
        argsDocum['ciudadContacto'] = miLista.options[miLista.selectedIndex].attributes[0].value
        argsDocum['cargoContacto'] = miLista.options[miLista.selectedIndex].attributes[1].value
        argsDocum['mailContacto'] = miLista.options[miLista.selectedIndex].attributes[2].value
        argsDocum['telContacto'] = miLista.options[miLista.selectedIndex].attributes[3].value
      }else{
        if(ev.target.name === "nombreUsuario"){
          let miLista = document.getElementById("miLista2");
  
          argsDocum['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
          argsDocum['cedula'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsDocum['ciudad'] = miLista.options[miLista.selectedIndex].attributes[1].value
          argsDocum['email'] = miLista.options[miLista.selectedIndex].attributes[2].value
          argsDocum['telefono'] = miLista.options[miLista.selectedIndex].attributes[3].value
        }else{
          if(ev.target.name === "titulo"){
            let miLista = document.getElementById("miLista1");
    
            argsDocum['titulo'] = miLista.options[miLista.selectedIndex].text
            argsDocum['descrPolitica'] = miLista.options[miLista.selectedIndex].attributes[0].value
            argsDocum['tipo'] = miLista.options[miLista.selectedIndex].attributes[1].value
            argsDocum['titulo2'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:""
            argsDocum['parrafo2'] = miLista.options[miLista.selectedIndex].attributes[3].value?miLista.options[miLista.selectedIndex].attributes[3].value:""
            argsDocum['titulo3'] = miLista.options[miLista.selectedIndex].attributes[4].value?miLista.options[miLista.selectedIndex].attributes[4].value:""
            argsDocum['parrafo3'] = miLista.options[miLista.selectedIndex].attributes[5].value?miLista.options[miLista.selectedIndex].attributes[5].value:""
          }else{
            if(ev.target.name === "descrEmpresa"){
              let miLista = document.getElementById("miLista");
              argsDocum['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
              argsDocum['pais'] = miLista.options[miLista.selectedIndex].attributes[4].value
              console.log(argsDocum)
              let listCon=[]
              listCon = this.props.list2.filter(elemento => elemento.descrEmpresa===miLista.options[miLista.selectedIndex].text)
            }else{
              argsDocum[ev.target.name] = ev.target.value
            }
          }
        }
      }
      this.setState({argsDocum});
    }
  }

  handleClickidListaI = async (ev, idLista, productoI)=>{
    ev.preventDefault()
    this.setState({descrProductoI: idLista.descrProducto})
    this.setState({numProductoCotiI: idLista.numProductoCoti})
  }
  idListaI = async (ev, idLista)=>{
    this.setState({productoI: idLista.descrProducto})
    this.setState({productoCotiI: idLista.numProductoCoti})
    ev.preventDefault()
  }

  handleQuestionUpdDel = async (ev, btn) => {
    if (btn && btn==="1"){
      var btnPress = await ev.target.attributes[0].value
      if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
        this.setState({open: true})
        this.setState({permiteBtn1: btn==="1"?true:false})

      }else{
        this.setState({open: false})
        this.setState({procBtn: 0})
        this.setState({permiteBtn1: true})

      };
      if(btnPress==="No"){
        this.setState({open: false})
        this.setState({procBtn: 0})
        this.setState({permiteBtn1: true})

      };
      if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        this.setState({procBtn: 1})
        this.setState({permiteBtn1: btn==="1"?true:false})

        const myBtn = document.getElementById("btnUpdDel");
        myBtn.click()
      }
    }else{
      var btnPress = await ev.target.attributes[0].value
      this.setState({permiteBtn1: false})
      if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
      if(btnPress==="No"){
        this.setState({open: false})
      };
      if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
      }    
    }
  }

  handleElimItem = async (ev, descrProductoI, idCoti, numCoti, numProductoCotiI)=>{
    if(descrProductoI){
      let tipoAc=''
      if(numProductoCotiI && numProductoCotiI>0){
        tipoAc = 'EliminarItemID'
      }else{
        tipoAc = 'EliminarItem'
      }
      const argsUpd = {
        descrProducto: descrProductoI,
        numProductoCoti: numProductoCotiI?numProductoCotiI:0,
        _id: idCoti
      }
      argsUpd.tipoAct = tipoAc
      await this.props.editCotizacion({variables: argsUpd});

      let argsBuscar=""
      argsBuscar += `'numCoti': '${numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista4: await data.allCotizacionRtes})
      this.setState({itemMod: "S"})
      this.setState({addItem: "N"})
      this.setState({descrProductoI: ""})
      this.setState({numProductoCotiI: 0})
      // this.props.allCotizacionRtes.refetch()
      // this.estadosFalse()
      // this.setState({showCotizacion: true})    
    }else{
      alert("!! Por favor seleccione el producto !!")
    }
  }

  render (){
    const {checked, argsDocum, confirmaAct, open, descrProductoI, productoI, permiteBtn1, permiteBtn2, lista4, numProductoCotiI, productoCotiI} = this.state;
    if(checked===true){
      argsDocum.estadoCoti = "Aprobada"
    }else{
      argsDocum.estadoCoti = "Creada"
    }

    let itemMod = this.state.itemMod
    let listCon=[], listItem=[]
    if (argsDocum.descrEmpresa){
      let empre=argsDocum.descrEmpresa
      listCon = this.props.list2.filter(elemento => elemento.descrEmpresa===empre)
    } 

    let listI = []
    let itemSelecc = "N"
    let mensaje1 = "Eliminar producto de la cotización "
    if(listI.length>0 && descrProductoI){
      mensaje1 = `Eliminar ${descrProductoI} de la cotización ${argsDocum.numCoti}`
      itemSelecc = "S"
    }else{
      mensaje1 += "(Seleccionar...)"
    }
    let imgIcon1 = "images/archivo_32.png"
if(this.props.addItem==="S"){
  itemMod = "N"
}

      if(itemMod==="S" && this.state.addItem==="N"){
        listI = lista4
        itemMod = "N"
        console.log("xxxxxxxxx")
      }else{
        listI = this.props.list4
        console.log("sssssssss")
      }

    const a353005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "353005" );


    let descrEmpresaAnt = this.props.idLista.descrEmpresa
    let tipoAnt = this.props.idLista.tipo
    let idCoti = this.props.idLista._id
    let numCoti = this.props.idLista.numCoti
    let controlElimI = "S"
    
    if(this.props.permiteUpdate || this.props.permiteDelete || !descrProductoI){
      controlElimI = "N"
    }
    console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Cotizaciones
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.handleElimItem(ev, descrProductoI, idCoti, numCoti, numProductoCotiI)
              :(ev)=>this.props.handleSubmit(ev, argsDocum, descrEmpresaAnt, tipoAnt)
            :()=>{}
          }
        >
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '20%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Ciudad y fecha</label>
                    <Form.Input autoComplete="off" name="ciudadFechaEnvio" id="ciudadFechaEnvio" value={argsDocum.ciudadFechaEnvio} onChange={this.handleChange} placeholder='Ciudad y fecha' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'ciudadFechaEnvio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Responsable</label>
                    <ListaOpe list={this.props.list3} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>    
                </div>
                <div className="column" style={{width: '15%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Empresa</label>
                    <ListaEmp list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Contacto</label>
                    <ListaCon list={listCon} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                
                </div>
                <div className="column" style={{width: '25%'}}>               
                <Form.Field>
                    <label style={this.props.styles.label}>Política comercial</label>
                    <ListaPol list={this.props.list1} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>   
                  <Form.Field>
                    <label style={this.props.styles.label}>Tiempo de entrega</label>
                    <ListaEnt styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                  
                </div>
                <div className="column" style={{width: '15%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Dirección exacta de entrega</label>
                    <Form.Input autoComplete="off" name="lugarEntrega" id="lugarEntrega" value={argsDocum.lugarEntrega} onChange={this.handleChange} placeholder='Dirección de entrega' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'lugarEntrega'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>     
                  <Form.Field>
                    <label style={this.props.styles.label}>Forma de pago</label>
                    <ListaPago styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> 
                </div>
                <div className="column" style={{width: '15%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Validez de la oferta</label>
                    <ListaOfer styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> 
                </div>
                <div className="column" style={{width: '10%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Moneda</label>
                    <ListaMon styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> 
                </div>
                <div className="column" style={{width: '25%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Referencia</label>
                    <Form.Input autoComplete="off" name="referencia" id="referencia" value={argsDocum.referencia} onChange={this.handleChange} placeholder='Referencia' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>   
                </div>
                <div className="column" style={{width: '25%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Cliente en zona franca (Sin impuestos)</label>
                    <ListaSN styles={this.props.styles} nameLista='zonaFranca' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>   
                </div>
                <div className="column" style={{width: '25%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Gestionar ingreso</label>
                    <ListaSN styles={this.props.styles} nameLista='gestionIngreso' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>   
                </div>
              </div>
            </div>
            <div className="row container">
              <div className="column" width="100%">  
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <textarea name="observaciones" id="observaciones" 
                    value={this.props.permiteUpdate?argsDocum.observaciones:this.props.idLista.observaciones} 
                    onChange={this.handleChange}>
                  </textarea>
                </Form.Field>              
              </div>
            </div>
            {a353005!==-1 &&
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '3%'}}>
                    <Form.Field>
                        <div className="column">
                          <input type='checkbox' id="aprobarCoti" name="aprobarCoti" style={this.props.styles.input} checked={checked} onChange={this.handleChange}/>
                        </div>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '17%'}}>
                    <Form.Field>
                      <div className="column">
                        <p style={{color: '#302b63', fontSize: '1.0em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                          &nbsp;&nbsp;APROBAR COTIZACION
                        </p> 
                      </div>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '80%'}}>  
                    <Form.Field>
                      <label style={this.props.styles.label}>Observaciones para aprobación</label>
                      <Form.Input autoComplete="off" name="observacionesAut" id="observacionesAut" value={argsDocum.observacionesAut} onChange={this.handleChange} placeholder='Observaciones de aprobación' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionesAut'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field> 
                  </div>
                </div>
              </div> 
            }
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
              <div style={{height: '14em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '52%'}}>Producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Vlr unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Moneda</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Dcto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Incremento</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Total producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Impto</th>
                    </tr>
                  </thead>
                  <Lista listI={listI} handleClickidListaI={this.handleClickidListaI} idListaI={this.idListaI}/>
                </table>
                <p></p>
              </div>
              {controlElimI === "S" &&
                <div className="column" style={{width: '100%', paddingTop: '0.3em'}}>
                  <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                    open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                </div>
              }
          </Form>
        </div>
      </div>
    )
  }
}

// export default VerCotizacion2
export default compose(
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Creada'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),


)(VerCotizacion2)
